// CSS files are all imported via index
import './index.css'

import './web-components/glsl-shader-canvas'
import './web-components/pattern'
import './web-components/presentation-note'
import './web-components/presentation-slide'
import './web-components/presentation'
import './web-components/shader-canvas'
import './web-components/shader'

import './vendor/instantpage'